/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type DeleteReleasePolicyPathParams = NonNullable<operations['DeleteReleasePolicy']['parameters']['path']>;

export interface Input extends DeleteReleasePolicyPathParams {
  apiVersion?: string;
  header: NonNullable<operations['DeleteReleasePolicy']['parameters']['header']>;
}

export async function DeleteReleasePolicy(
  { apiVersion, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().DELETE('/api/v2/projects/{projectKey}/release-policies/{policyKey}', {
    params: { path, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
